<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Organisationen
                    </h3>
                </div>
                <div class="col text-right">
                    <base-button type="primary" size="sm" v-on:click="$router.push('/customer/create')" icon="ni ni-fat-add"></base-button>
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <TableHeadFilter title="#" :has-sort="true" @input="changePage(1)"><TableSortControl v-model="tableOptions.sort.id" @input="changePage(1)"></TableSortControl></TableHeadFilter>
                    <TableHeadFilter title="Name" v-model="tableOptions.filter.name" :has-filter="true" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Straße & Nr" v-model="tableOptions.filter.street" :has-filter="true" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Postleitzahl" v-model="tableOptions.filter.postalcode" :has-filter="true" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Ort" v-model="tableOptions.filter.city" :has-filter="true" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Land" v-model="tableOptions.filter.country" :has-filter="true" filter-type="dropdown" :dropdown-list="$store.getters['country/showCountryCollection']" @input="changePage(1)"></TableHeadFilter>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <th scope="row">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.id}}</div>
                    </th>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.name}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.street}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.postalcode}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.city}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{ (row.country) ? row.country.name : '' }}</div>
                    </td>
                    <td class="text-right"><div v-if="isLoading" class="loading-button"> </div><div v-else>
                        <base-dropdown class="dropdown"
                                       position="right">
                            <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-ellipsis-v"></i>
                            </a>
                            <template>
                                <router-link class="dropdown-item" :to="'/customer/edit/'+row.id">Anzeigen und editieren</router-link>
                            </template>
                        </base-dropdown></div>
                    </td>
                </template>
            </base-table>
        </div>

        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>

    </div>
</template>

<script>
    import TableHeadFilter from "@/components/TableHeadFilter";
    import TableSortControl from "@/components/TableSortControl";
    export default {
        name: "list",
        components:{TableSortControl, TableHeadFilter},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                tableOptions: {
                    filter: {
                        name: null,
                        street: null,
                        postalcode: null,
                        city: null,
                        country: null
                    },
                    dateFilter: {
                    },
                    sort:{
                        id: 'ASC'
                    }},
                tableData: [
                    {
                        id: 0,
                        name: "string",
                        street: "string",
                        postalcode: 0,
                        city: "string",
                        country: "string",
                    }
                ],
                totalitems: 0,
                page: 1,
                isLoading: false,
            }
        },
        created() {
          this.changePage(this.page);
          if (!this.$store.getters['country/isReady']) this.$store.dispatch('country/getCountryCollection');
        },
        methods: {
            changePage(page) {
                this.isLoading = true;
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.isLoading = false;
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/customers?`+ this.getUrlExtension(this.tableOptions.filter,this.tableOptions.sort,this.tableOptions.dateFilter) +`page=` + page, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            }
        }
    }
</script>

<style scoped>

</style>